module.exports = __webpack_public_path__ + "img/text-classify10.39c0ebb6.png";